import React from "react";
import { IState } from "../../../../../common/state/IState";
import { umSpPageStateSelector } from "../selectors";
import { ICustomerConfig } from "../../_features/loadDynamicContent/LoadDynamicContentModel";
import { useSelector } from "react-redux";

const i18n = {
    firstNamePlaceHolder: "first.name",
};

function selector(s: IState) {
    const umSpPageState = umSpPageStateSelector(s);
    return getFirstName(
        umSpPageState?.auth?.user,
        umSpPageState?.dynamicContent?.config
    );
}

function getFirstName(user: any, config: ICustomerConfig) {
    if (!user || !config) return i18n.firstNamePlaceHolder;

    if (config.firstNameField && user[config.firstNameField])
        return user[config.firstNameField];

    if (config.lastNameField && user[config.lastNameField])
        return user[config.lastNameField];

    return i18n.firstNamePlaceHolder;
}

export const UmSpDcFirstNameElement = ({ className = "" }) => (
    <span className={className}>{useSelector(selector)}</span>
);
